import { render, staticRenderFns } from "./CaptainsDeck.vue?vue&type=template&id=98b71eea&scoped=true&"
import script from "./CaptainsDeck.vue?vue&type=script&lang=js&"
export * from "./CaptainsDeck.vue?vue&type=script&lang=js&"
import style0 from "./CaptainsDeck.vue?vue&type=style&index=0&id=98b71eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b71eea",
  null
  
)

export default component.exports